const mEditionBillingMyCharges = {
  mEditionBillingMyCharges: {
    alerts: {
      updateVentasAnularPago: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'Pago Anulado'
      },

      updateVentasConfirmarPago: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'Pago Confirmado'
      },

      updateVentasReembolsarPago: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'Pago Reembolsado'
      }
    },

    buttonSecondary: {
      download: {
        subText: 'Formato',
        text: 'Exportar'
      },

      filterText: 'Filtros'
    },

    table: {
      thClient: 'ALUMNO',
      thDate: 'FECHA',
      thDiscount: 'DESC.',
      thDivisa: 'DIVISA',
      thDetail: 'DETALLE',
      thExpirationDate: 'FECHA VENC.',
      thInvoice: 'COMP.',
      thMethod: 'MEDIO',
      thPaymentDate: 'FECHA PAGO',
      thTotal: 'TOTAL'
    },

    toggleState: {
      cancel: 'Anular Pago',
      confirm: 'Confirmar Pago',
      refund: 'Reembolsar'
    },

    tooltips: {
      actions: 'Acciones',
      invoice: 'Ver Comprobante'
    }
  }
}

export default mEditionBillingMyCharges
